import { Anchor, Menu } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import type React from "react";

export const AdminMenu: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Menu>
            <Menu.Target>
                <Anchor fz="14px" role="button" aria-haspopup="menu">
                    Admin Area
                </Anchor>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Label>Reports</Menu.Label>
                <Menu.Item onClick={() => navigate({ to: "/feedback" })}>Users Feedback</Menu.Item>
                <Menu.Divider />
                <Menu.Label>User Management</Menu.Label>
                <Menu.Item onClick={() => navigate({ to: "/manageUsers" })}>Manage Users</Menu.Item>
                <Menu.Item onClick={() => navigate({ to: "/manageRoles" })}>Manage Roles</Menu.Item>
                <Menu.Item onClick={() => navigate({ to: "/manageRequests" })}>
                    Manage Requests
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};
